import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const PrinterSettings = ({ handleChange, printerSettings, printerSettingsPopulated }) => {
  const [dropdownOption, setDropdownOption] = useState(null);

  if (!printerSettings) {
    return (
      <h5 className="not-found-text">
        {t('No printer settings available, contact')}
        <a className="support-link" href="mailto:support@brandfolder.com">support</a>
        {t('to setup printer settings')}
      </h5>
    );
  }

  return printerSettings.map(({ copy, data, id, size, type }) => {
    if (type === 'input') {
      return (
        <React.Fragment key={id}>
          <label className="bf-label" htmlFor={id}>{copy}
            <input
              id={id}
              className={`bf-input ${size} ${id}`}
              defaultValue={printerSettingsPopulated[id] || ''}
              onChange={(e) => handleChange(id, e.target.value)}
              required
            />
          </label>
          { id === 'quantity' ? <div className="form-placeholder-div" /> : null }
        </React.Fragment>
      );
    }

    if (type === 'textarea') {
      return (
        <label key={id} className="bf-label label-textarea" htmlFor={id}>{copy}
          <textarea
            id={id}
            className={`bf-textarea ${size} ${id}`}
            defaultValue={printerSettingsPopulated[id] || ''}
            onChange={(e) => handleChange(id, e.target.value)}
            required
          />
        </label>
      );
    }

    if (type === 'text') {
      return <p key={id} className="form-text">{copy}</p>;
    }

    if (type === 'dropdown') {
      const options = data.map((option) => ({ label: option, value: option }));

      return (
        <label key={id} className="bf-label dropdown-label" htmlFor={id}>
          {copy}
          <Select
            className={`${id}-dropdown ${size}`}
            placeholder="Select an option"
            onChange={(selection) => {
              handleChange(id, selection ? selection.value : null);
              setDropdownOption(selection);
            }}
            options={options}
            searchable
            value={dropdownOption}
          />
        </label>
      );
    }

    return null;
  });
};

PrinterSettings.propTypes = {
  handleChange: PropTypes.func.isRequired,
  printerSettings: PropTypes.arrayOf(PropTypes.shape({
    copy: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.string,
    order: PropTypes.number,
    size: PropTypes.string,
  })),
  printerSettingsPopulated: PropTypes.shape({}),
};

PrinterSettings.defaultProps = {
  printerSettings: null,
};

export default PrinterSettings;
